var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "nav-wrapper" }, [
      _c("div", { staticClass: "stage-title" }, [
        _vm._v("\n      " + _vm._s(_vm.stageTitle) + "\n    "),
      ]),
      _c("div", { staticClass: "slot-content" }, [_vm._t("default")], 2),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }